import { useMemo } from 'react';
import { treeSearch } from 'utils/object';
import { ITreeItem } from 'types';

export const useTreeSearch = <T extends ITreeItem>(
  options: T[],
  searchField: string,
  idField: string,
  searchTerm?: string
): { nodes: T[]; expandIDS: string[] } => {
  return useMemo(() => {
    if (searchTerm) {
      return treeSearch(searchTerm, options, searchField, idField);
    }
    return { nodes: options, expandIDS: [] };
  }, [searchTerm, options, searchField, idField]);
};
